import { Box } from "@mui/material";

export const MyCafeteriaDivider = () => {
  return <Box height="16px" />;
};

export default MyCafeteriaDivider;
